/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AcceptEntityInvitationBody,
  AcceptEntityInvitationParams,
  AcceptInvitationResponse,
  CancelEntityInvitation200,
  EntityInvitation,
  EntityInvitationsList,
  Error,
  ResendInvitationResponse,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve all invitations for the current entity, including pending, accepted, and expired.
 * @summary List entity invitations
 */
export type listEntityInvitationsResponse200 = {
  data: EntityInvitationsList
  status: 200
}

export type listEntityInvitationsResponse400 = {
  data: Error
  status: 400
}

export type listEntityInvitationsResponse401 = {
  data: Error
  status: 401
}

export type listEntityInvitationsResponse403 = {
  data: Error
  status: 403
}

export type listEntityInvitationsResponse404 = {
  data: Error
  status: 404
}

export type listEntityInvitationsResponse500 = {
  data: Error
  status: 500
}

export type listEntityInvitationsResponseSuccess = (listEntityInvitationsResponse200) & {
  headers: Headers;
};
export type listEntityInvitationsResponseError = (listEntityInvitationsResponse400 | listEntityInvitationsResponse401 | listEntityInvitationsResponse403 | listEntityInvitationsResponse404 | listEntityInvitationsResponse500) & {
  headers: Headers;
};

export type listEntityInvitationsResponse = (listEntityInvitationsResponseSuccess | listEntityInvitationsResponseError)

export const getListEntityInvitationsUrl = () => {


  

  return `/entities/invitations`
}

export const listEntityInvitations = async ( options?: RequestInit): Promise<listEntityInvitationsResponse> => {
  
  return customFetch<listEntityInvitationsResponse>(getListEntityInvitationsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve details of a specific invitation.
 * @summary Get entity invitation
 */
export type getEntityInvitationResponse200 = {
  data: EntityInvitation
  status: 200
}

export type getEntityInvitationResponse400 = {
  data: Error
  status: 400
}

export type getEntityInvitationResponse401 = {
  data: Error
  status: 401
}

export type getEntityInvitationResponse403 = {
  data: Error
  status: 403
}

export type getEntityInvitationResponse404 = {
  data: Error
  status: 404
}

export type getEntityInvitationResponse500 = {
  data: Error
  status: 500
}

export type getEntityInvitationResponseSuccess = (getEntityInvitationResponse200) & {
  headers: Headers;
};
export type getEntityInvitationResponseError = (getEntityInvitationResponse400 | getEntityInvitationResponse401 | getEntityInvitationResponse403 | getEntityInvitationResponse404 | getEntityInvitationResponse500) & {
  headers: Headers;
};

export type getEntityInvitationResponse = (getEntityInvitationResponseSuccess | getEntityInvitationResponseError)

export const getGetEntityInvitationUrl = (id: string,) => {


  

  return `/entities/invitations/${id}`
}

export const getEntityInvitation = async (id: string, options?: RequestInit): Promise<getEntityInvitationResponse> => {
  
  return customFetch<getEntityInvitationResponse>(getGetEntityInvitationUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Cancel a pending invitation. Cannot cancel already accepted invitations.
 * @summary Cancel invitation
 */
export type cancelEntityInvitationResponse200 = {
  data: CancelEntityInvitation200
  status: 200
}

export type cancelEntityInvitationResponse400 = {
  data: Error
  status: 400
}

export type cancelEntityInvitationResponse401 = {
  data: Error
  status: 401
}

export type cancelEntityInvitationResponse403 = {
  data: Error
  status: 403
}

export type cancelEntityInvitationResponse404 = {
  data: Error
  status: 404
}

export type cancelEntityInvitationResponse422 = {
  data: ValidationError
  status: 422
}

export type cancelEntityInvitationResponse500 = {
  data: Error
  status: 500
}

export type cancelEntityInvitationResponseSuccess = (cancelEntityInvitationResponse200) & {
  headers: Headers;
};
export type cancelEntityInvitationResponseError = (cancelEntityInvitationResponse400 | cancelEntityInvitationResponse401 | cancelEntityInvitationResponse403 | cancelEntityInvitationResponse404 | cancelEntityInvitationResponse422 | cancelEntityInvitationResponse500) & {
  headers: Headers;
};

export type cancelEntityInvitationResponse = (cancelEntityInvitationResponseSuccess | cancelEntityInvitationResponseError)

export const getCancelEntityInvitationUrl = (id: string,) => {


  

  return `/entities/invitations/${id}`
}

export const cancelEntityInvitation = async (id: string, options?: RequestInit): Promise<cancelEntityInvitationResponse> => {
  
  return customFetch<cancelEntityInvitationResponse>(getCancelEntityInvitationUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Resend an invitation email with a new token and extended expiry.
 * @summary Resend invitation
 */
export type resendEntityInvitationResponse200 = {
  data: ResendInvitationResponse
  status: 200
}

export type resendEntityInvitationResponse400 = {
  data: Error
  status: 400
}

export type resendEntityInvitationResponse401 = {
  data: Error
  status: 401
}

export type resendEntityInvitationResponse403 = {
  data: Error
  status: 403
}

export type resendEntityInvitationResponse404 = {
  data: Error
  status: 404
}

export type resendEntityInvitationResponse422 = {
  data: ValidationError
  status: 422
}

export type resendEntityInvitationResponse500 = {
  data: Error
  status: 500
}

export type resendEntityInvitationResponseSuccess = (resendEntityInvitationResponse200) & {
  headers: Headers;
};
export type resendEntityInvitationResponseError = (resendEntityInvitationResponse400 | resendEntityInvitationResponse401 | resendEntityInvitationResponse403 | resendEntityInvitationResponse404 | resendEntityInvitationResponse422 | resendEntityInvitationResponse500) & {
  headers: Headers;
};

export type resendEntityInvitationResponse = (resendEntityInvitationResponseSuccess | resendEntityInvitationResponseError)

export const getResendEntityInvitationUrl = (id: string,) => {


  

  return `/entities/invitations/${id}/resend`
}

export const resendEntityInvitation = async (id: string, options?: RequestInit): Promise<resendEntityInvitationResponse> => {
  
  return customFetch<resendEntityInvitationResponse>(getResendEntityInvitationUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Accept an entity invitation by providing user details. Creates a new user account and grants entity access. Returns an access token for immediate use.
 * @summary Accept invitation
 */
export type acceptEntityInvitationResponse200 = {
  data: AcceptInvitationResponse
  status: 200
}

export type acceptEntityInvitationResponse400 = {
  data: Error
  status: 400
}

export type acceptEntityInvitationResponse401 = {
  data: Error
  status: 401
}

export type acceptEntityInvitationResponse403 = {
  data: Error
  status: 403
}

export type acceptEntityInvitationResponse404 = {
  data: Error
  status: 404
}

export type acceptEntityInvitationResponse422 = {
  data: ValidationError
  status: 422
}

export type acceptEntityInvitationResponse500 = {
  data: Error
  status: 500
}

export type acceptEntityInvitationResponseSuccess = (acceptEntityInvitationResponse200) & {
  headers: Headers;
};
export type acceptEntityInvitationResponseError = (acceptEntityInvitationResponse400 | acceptEntityInvitationResponse401 | acceptEntityInvitationResponse403 | acceptEntityInvitationResponse404 | acceptEntityInvitationResponse422 | acceptEntityInvitationResponse500) & {
  headers: Headers;
};

export type acceptEntityInvitationResponse = (acceptEntityInvitationResponseSuccess | acceptEntityInvitationResponseError)

export const getAcceptEntityInvitationUrl = (params: AcceptEntityInvitationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/invitations/accept?${stringifiedParams}` : `/invitations/accept`
}

export const acceptEntityInvitation = async (acceptEntityInvitationBody: AcceptEntityInvitationBody,
    params: AcceptEntityInvitationParams, options?: RequestInit): Promise<acceptEntityInvitationResponse> => {
  
  return customFetch<acceptEntityInvitationResponse>(getAcceptEntityInvitationUrl(params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      acceptEntityInvitationBody,)
  }
);}
  

